(function() {
  'use strict';

  var CATEGORIES = [
    { label: 'Getting Started', tag: 'get-started-weaving' },
    { label: 'Yarn', tag: 'yarn' },
    { label: 'Project Planning', tag: 'project-planning' },
    { label: 'Finishing', tag: 'finishing-tips-techniques' },
    { label: 'Tips & Tutorials', tag: 'tips-tricks' },
    { label: 'Troubleshooting', tag: 'troubleshooting' }
  ];

  var BLOG_HANDLE = 'how-to-weave';
  var DEBOUNCE_MS = 300;
  var MIN_QUERY_LENGTH = 2;

  // Use shared search enhancer (search-enhancer.js)
  var GS = window.GistSearch || {};
  var extractKeywords = GS.extractKeywords || function(t) { return t.toLowerCase().split(/\s+/); };
  var expandWithSynonyms = GS.expandWithSynonyms || function(k) { return k; };

  var container;
  var input;
  var clearBtn;
  var pillsContainer;
  var resultsContainer;
  var activePill = null;
  var debounceTimer = null;
  var categoryCache = {};

  function init() {
    container = document.querySelector('[data-resource-search]');
    if (!container) return;

    input = container.querySelector('[data-resource-search-input]');
    clearBtn = container.querySelector('[data-resource-search-clear]');
    pillsContainer = container.querySelector('[data-resource-search-pills]');
    resultsContainer = container.querySelector('[data-resource-search-results]');

    buildPills();
    bindEvents();
  }

  function buildPills() {
    CATEGORIES.forEach(function(cat) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'resource-search__pill';
      pill.textContent = cat.label;
      pill.setAttribute('data-tag', cat.tag);
      pill.addEventListener('click', function() { onPillClick(cat, pill); });
      pillsContainer.appendChild(pill);
    });
  }

  function bindEvents() {
    input.addEventListener('input', function() {
      updateClearButton();
      clearActivePill();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        var term = input.value.trim();
        if (term.length >= MIN_QUERY_LENGTH) {
          searchArticles(term);
        } else {
          clearResults();
        }
      }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        input.value = '';
        updateClearButton();
        clearResults();
        clearActivePill();
        input.blur();
      }
    });

    clearBtn.addEventListener('click', function() {
      input.value = '';
      updateClearButton();
      clearResults();
      clearActivePill();
      input.focus();
    });
  }

  function updateClearButton() {
    if (input.value.length > 0) {
      clearBtn.classList.add('resource-search__clear--visible');
    } else {
      clearBtn.classList.remove('resource-search__clear--visible');
    }
  }

  function onPillClick(cat, pill) {
    if (activePill === pill) {
      clearActivePill();
      clearResults();
      return;
    }

    clearActivePill();
    activePill = pill;
    pill.classList.add('resource-search__pill--active');
    input.value = '';
    updateClearButton();
    browseCategory(cat);
  }

  function clearActivePill() {
    if (activePill) {
      activePill.classList.remove('resource-search__pill--active');
      activePill = null;
    }
  }

  /* --- Query processing --- */
  function buildSearchQueries(term) {
    var keywords = extractKeywords(term);
    var expanded = expandWithSynonyms(keywords);
    var queries = [];

    // 1. Original term as-is (user may have typed an exact title)
    queries.push(term.trim());

    // 2. Keywords only (stop words removed)
    if (keywords.length > 0) {
      var keywordQuery = keywords.join(' ');
      if (queries.indexOf(keywordQuery) === -1) queries.push(keywordQuery);
    }

    // 3. Expanded with synonyms
    if (expanded.length > keywords.length) {
      var expandedQuery = expanded.join(' ');
      if (queries.indexOf(expandedQuery) === -1) queries.push(expandedQuery);
    }

    // 4. Individual important keywords (for broad fallback)
    keywords.forEach(function(word) {
      if (word.length >= 4 && queries.indexOf(word) === -1) {
        queries.push(word);
      }
    });

    // 5. Individual synonyms that are multi-word phrases
    expanded.forEach(function(syn) {
      if (syn.indexOf(' ') !== -1 && queries.indexOf(syn) === -1) {
        queries.push(syn);
      }
    });

    return queries;
  }

  function fetchPredictiveSearch(query) {
    var url = window.PXUTheme.routes.predictive_search_url
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=article'
      + '&resources[limit]=10';

    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function(data) {
        return data.resources && data.resources.results && data.resources.results.articles
          ? data.resources.results.articles
          : [];
      })
      .catch(function() { return []; });
  }

  function scoreArticle(article, keywords) {
    var title = article.title.toLowerCase();
    var url = article.url || '';
    var score = 0;

    // Boost how-to-weave articles, penalize podcast
    if (url.indexOf('/blogs/how-to-weave/') !== -1) score += 10;
    else if (url.indexOf('/blogs/journal/') !== -1) score += 5;
    else if (url.indexOf('/blogs/podcast/') !== -1) score += 0;

    // Score by keyword matches in title
    keywords.forEach(function(kw) {
      if (title.indexOf(kw.toLowerCase()) !== -1) score += 5;
    });

    return score;
  }

  /* --- Free-text search with smart fallback --- */
  function searchArticles(term) {
    showLoading();
    var displayTerm = term;
    var queries = buildSearchQueries(term);
    var keywords = extractKeywords(term);
    var expanded = expandWithSynonyms(keywords);
    var allKeywords = keywords.concat(expanded);

    // Run queries in phases: first the tight ones, then broader only if needed
    var tightQueries = queries.slice(0, 3); // original, keywords, synonym-expanded
    var broadQueries = queries.slice(3);    // individual words

    runSearchPhase(tightQueries, {}, function(merged) {
      var count = Object.keys(merged).length;
      if (count >= 3) {
        finishSearch(merged, allKeywords, displayTerm);
      } else {
        // Not enough — try broader queries
        runSearchPhase(broadQueries, merged, function(merged2) {
          finishSearch(merged2, allKeywords, displayTerm);
        });
      }
    });
  }

  function stripTrackingParams(url) {
    return url.split('?')[0];
  }

  function runSearchPhase(queries, merged, callback) {
    if (queries.length === 0) { callback(merged); return; }

    var remaining = queries.length;
    queries.forEach(function(query) {
      fetchPredictiveSearch(query).then(function(articles) {
        articles.forEach(function(article) {
          var key = stripTrackingParams(article.url);
          if (!merged[key]) {
            article.url = key;
            merged[key] = article;
          }
        });
        remaining--;
        if (remaining === 0) callback(merged);
      });
    });
  }

  function finishSearch(merged, allKeywords, displayTerm) {
    var articles = Object.keys(merged).map(function(url) { return merged[url]; });

    // Score and sort by relevance
    articles.forEach(function(a) { a._score = scoreArticle(a, allKeywords); });
    articles.sort(function(a, b) { return b._score - a._score; });

    // Drop low-scoring results if we have enough good ones
    var goodArticles = articles.filter(function(a) { return a._score >= 5; });
    if (goodArticles.length >= 3) {
      articles = goodArticles;
    }

    // Cap at 8 results
    articles = articles.slice(0, 8);

    renderSearchResults(articles, displayTerm);

    // Search analytics
    if (window.GistSearch && window.GistSearch.logSearch) {
      var expanded = expandWithSynonyms(extractKeywords(displayTerm));
      window.GistSearch.logSearch({
        query: displayTerm,
        enhanced: expanded.join(' '),
        path: 'resource',
        resultCount: articles.length
      });
    }
  }

  function renderSearchResults(articles, term) {
    if (articles.length === 0) {
      resultsContainer.innerHTML = '<p class="resource-search__no-results">No resources found for &ldquo;' + escapeHtml(term) + '&rdquo;</p>';
      return;
    }

    var html = '<h3 class="resource-search__results-heading">Results for &ldquo;' + escapeHtml(term) + '&rdquo;</h3>';
    html += '<ul class="resource-search__results-list">';

    articles.forEach(function(article) {
      html += buildArticleItem(article.title, article.url, article.image);
    });

    html += '</ul>';
    html += '<a class="resource-search__view-all" href="/search?type=article&q=' + encodeURIComponent(term) + '">View all results &rarr;</a>';

    resultsContainer.innerHTML = html;
  }

  /* --- Category browsing via blog tag page fetch --- */
  function browseCategory(cat) {
    if (categoryCache[cat.tag]) {
      renderCategoryResults(categoryCache[cat.tag], cat);
      return;
    }

    showLoading();

    var url = '/blogs/' + BLOG_HANDLE + '/tagged/' + cat.tag;

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function(html) {
        var articles = parseArticlesFromHtml(html);
        categoryCache[cat.tag] = articles;
        renderCategoryResults(articles, cat);
      })
      .catch(function() {
        resultsContainer.innerHTML = '<p class="resource-search__no-results">Could not load ' + escapeHtml(cat.label) + ' resources.</p>';
      });
  }

  function parseArticlesFromHtml(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var articles = [];
    var seen = {};

    // Find article title links — Turbo uses h2.article__title > a
    var titleLinks = doc.querySelectorAll('h2.article__title a[href*="/blogs/' + BLOG_HANDLE + '/"]');

    titleLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (!href) return;
      if (href.indexOf('/tagged/') !== -1) return;

      var path = href.replace(/^https?:\/\/[^/]+/, '');
      if (seen[path]) return;
      seen[path] = true;

      var title = link.textContent.trim();
      if (!title || title.length < 3) return;

      // Find the article image — look for an img in a sibling or parent container
      // that links to the same article URL
      var imgSrc = '';
      var allImgLinks = doc.querySelectorAll('a[href="' + href + '"] img, a[href="' + path + '"] img');
      for (var i = 0; i < allImgLinks.length; i++) {
        var img = allImgLinks[i];
        // Prefer data-src (lazy loaded full image) over src (placeholder)
        var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
        // Skip SVG placeholders
        if (src && src.indexOf('data:image/svg') === -1) {
          imgSrc = src;
          break;
        }
      }

      articles.push({
        title: title,
        url: path,
        image: imgSrc
      });
    });

    // Fallback: if no h2.article__title found, try broader link search
    if (articles.length === 0) {
      var links = doc.querySelectorAll('a[href*="/blogs/' + BLOG_HANDLE + '/"]');
      links.forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href) return;
        if (href.indexOf('/tagged/') !== -1) return;
        if (href === '/blogs/' + BLOG_HANDLE || href === '/blogs/' + BLOG_HANDLE + '/') return;

        var path = href.replace(/^https?:\/\/[^/]+/, '');
        if (seen[path]) return;
        seen[path] = true;

        var title = link.textContent.trim();
        if (!title || title.length < 3) return;
        var lower = title.toLowerCase();
        if (lower === 'read more' || lower === 'continue reading') return;

        var img = link.querySelector('img');
        var imgSrc = '';
        if (img) {
          imgSrc = img.getAttribute('data-src') || img.getAttribute('src') || '';
          if (imgSrc.indexOf('data:image/svg') !== -1) imgSrc = '';
        }

        articles.push({
          title: title,
          url: path,
          image: imgSrc
        });
      });
    }

    return articles;
  }

  function renderCategoryResults(articles, cat) {
    if (articles.length === 0) {
      resultsContainer.innerHTML = '<p class="resource-search__no-results">No resources found in ' + escapeHtml(cat.label) + '.</p>'
        + '<a class="resource-search__view-all" href="/blogs/' + BLOG_HANDLE + '/tagged/' + encodeURIComponent(cat.tag) + '">Browse ' + escapeHtml(cat.label) + ' on the blog &rarr;</a>';
      return;
    }

    var html = '<h3 class="resource-search__results-heading">' + escapeHtml(cat.label) + '</h3>';
    html += '<ul class="resource-search__results-list">';

    articles.forEach(function(article) {
      html += buildArticleItem(article.title, article.url, article.image);
    });

    html += '</ul>';
    html += '<a class="resource-search__view-all" href="/blogs/' + BLOG_HANDLE + '/tagged/' + encodeURIComponent(cat.tag) + '">View all ' + escapeHtml(cat.label) + ' resources &rarr;</a>';

    resultsContainer.innerHTML = html;
  }

  /* --- Shared rendering --- */
  function buildArticleItem(title, url, image) {
    var imageHtml = '';
    if (image) {
      var imgSrc = (typeof image === 'object' && image.url) ? image.url : image;
      if (typeof imgSrc === 'string' && imgSrc.length > 0) {
        imageHtml = '<img class="resource-search__result-image" src="' + escapeAttr(imgSrc) + '" alt="" loading="lazy">';
      }
    }

    var blogLabel = '';
    if (typeof url === 'string') {
      if (url.indexOf('/blogs/journal/') !== -1) {
        blogLabel = 'Journal';
      } else if (url.indexOf('/blogs/how-to-weave/') !== -1) {
        blogLabel = 'How to Weave';
      } else if (url.indexOf('/blogs/podcast/') !== -1) {
        blogLabel = 'Podcast';
      }
    }

    var html = '<li class="resource-search__result-item">';
    html += '<a class="resource-search__result-link" href="' + escapeAttr(url) + '">';
    html += imageHtml;
    html += '<div class="resource-search__result-content">';
    html += '<p class="resource-search__result-title">' + escapeHtml(title) + '</p>';
    if (blogLabel) {
      html += '<p class="resource-search__result-blog">' + blogLabel + '</p>';
    }
    html += '</div>';
    html += '</a>';
    html += '</li>';
    return html;
  }

  function showLoading() {
    resultsContainer.innerHTML = '<p class="resource-search__loading">Searching&hellip;</p>';
  }

  function clearResults() {
    resultsContainer.innerHTML = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
